import React, { useEffect } from 'react';
import {
  Button,
  FooterActionBar,
  Icon,
  InputField,
  Tooltip,
  Typography,
} from '@saviynt/design-system';
import classNames from 'classnames';

import { useInvertedLocalize } from '../../../../utils';

import messages from './messages';

import './IDPSettings.css';

export default function IDPSettings({
  value,
  setValue,
  isMenuPinned,
  onSave,
  isSaving,
  isSaveDisabled,
}: {
  value: string;
  setValue: (v: string) => void;
  isMenuPinned: boolean;
  onSave: () => void;
  isSaving: boolean;
  isSaveDisabled: boolean;
}) {
  const l = useInvertedLocalize(messages);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--external-hours-text',
      `"${l('Hours')}"`
    );
    
    return () => {
      document.documentElement.style.removeProperty('--external-hours-text');
    }
  }, [l]);

  return (
    <>
      <div className='Ext-IDPProviders-tabcontent-expiredTime-contentWrapper'>
        <InputField
          name='verification-expire'
          placeholder=''
          type='text'
          inputmode='numeric'
          label={
            <Typography
              className='Ext-IDPProviders-tabcontent-expiredTime-contentWrapper-inputLabel'
              kind='label'
              htmlFor='verification-expire'>
              {l('Verification Link Expiry Duration')}
              <Tooltip
                trigger={
                  <Icon
                    kind='AlertInfoFilled'
                    color='--color-foreground-info-medium'
                  />
                }
                text={l(
                  'Specify how long the verification link should remain valid. After this time, users will no longer be able to complete identity verification using the link.'
                )}
                placement='top'
                openDelay={0}
                isWordBreak
                maxWidth='20rem'
                className='Ext-IDPProviders-tabcontent-expiredTime-contentWrapper-inputLabel-tooltip'
              />
            </Typography>
          }
          value={value}
          setValue={setValue}
          className='Ext-IDPProviders-tabcontent-expiredTime-contentWrapper-input'
          classNames={{
            inputWrapper: 'Ext-IDPProviders-tabcontent-expiredTime-wrapper',
          }}
        />
      </div>
      <div
        className={classNames(
          'Ext-IDPProviders-tabcontent-expiredTime-footer',
          isMenuPinned &&
            'Ext-IDPProviders-tabcontent-expiredTime-footer--isMenuPinned'
        )}>
        <FooterActionBar className='Ext-IDPProviders-tabcontent-expiredTime-footer-actionBar'>
          <Button
            kind='filled'
            loaderText='Saving'
            onClick={onSave}
            isLoading={isSaving}
            isDisabled={isSaveDisabled}>
            {l('Save')}
          </Button>
        </FooterActionBar>
      </div>
    </>
  );
}
